import React, { useState } from 'react';
import { Line, Empty } from '../Line';
import { LinkPreview } from '../../ui/link-preview';
import { SpecialText } from '../../ui/special-text';

const ProjectsView = ({ onRunTstyles }) => {
  const [linkReady, setLinkReady] = useState({});
  const projects = [
    {
      title: 'TerminalStyles - Terminal Theme Switcher',
      descBefore: '',
      descLinkText: null,
      descLinkUrl: null,
      descLinkImg: null,
      descAfter: 'PowerShell module on the PowerShell Gallery that themes your terminal live. Arrow through 15 bundled styles previewing each one in the current tab, Enter keeps it and Esc reverts exactly how it was. Sets color scheme, cursor, font, opacity and background in one command, and installs coding fonts from their official sources. Works on Windows Terminal, Terminal.app, iTerm2 and anything speaking OSC sequences, styling zsh and bash as well as PowerShell.',
      technologies: ['PowerShell', 'Pester', 'ANSI / OSC', 'Windows Terminal', 'iTerm2'],
      tryCommand: ':tstyles',
      liveUrl: 'https://www.powershellgallery.com/packages/TerminalStyles',
      githubUrl: 'https://github.com/fcreme/TerminalStyles',
    },
    {
      title: 'TIDE Active - Personal Brand',
      descBefore: '',
      descLinkText: 'Personal brand website',
      descLinkUrl: 'https://tideactive.com/',
      descLinkImg: '/tide2.webp',
      descAfter: ' for fitness and lifestyle trainer. Complete platform with modern design, responsive and optimized for conversion.',
      technologies: ['React', 'Next.js', 'Tailwind CSS', 'Framer Motion'],
      liveUrl: 'https://tideactive.com/',
      githubUrl: 'https://github.com/fcreme/tideactive-personal-brand',
    },
    {
      title: 'OnChain - DeFi Interface',
      descBefore: '',
      descLinkText: 'Modern DeFi interface',
      descLinkUrl: null,
      descLinkImg: '/onchain.webp',
      descAfter: ' for interacting with ERC20 tokens on Ethereum Sepolia testnet. Multi-wallet connectivity, real-time balances, token transfers, approvals and minting with glassmorphism UI.',
      technologies: ['React', 'TypeScript', 'Wagmi', 'RainbowKit', 'Material-UI', 'Zustand'],
      liveUrl: null,
      githubUrl: 'https://github.com/fcreme/OnChainApp',
    },
    {
      title: 'Digital Wounds - Atmospheric Experience',
      descBefore: '',
      descLinkText: null,
      descLinkUrl: null,
      descLinkImg: null,
      descAfter: 'Native C++ dark atmospheric desktop experience inspired by Resident Evil Remake and Silent Hill. Hybrid rendering with pre-rendered Blender backgrounds, real-time 3D objects, interactive books, dynamic lighting, and cinematic post-processing effects (film grain, vignette, bloom).',
      technologies: ['C++17', 'SDL2', 'OpenGL', 'GLSL', 'CMake', 'Blender'],
      liveUrl: null,
      githubUrl: 'https://github.com/fcreme/digital-wounds',
    },
  ];

  let n = 0;
  const l = () => ++n;
  let d = 0;
  const next = (step = 0.03) => { d += step; return d; };

  return (
    <div className="content-view">
      <Line n={l()}>
        <SpecialText speed={5} delay={next()} className="syn-comment">{'// projects.tsx — Featured Projects'}</SpecialText>
      </Line>
      <Empty n={l()} />
      <Line n={l()}>
        <SpecialText speed={5} delay={next()} className="syn-keyword">{'interface '}</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-type">Project</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">{' {'}</SpecialText>
      </Line>
      <Line n={l()}>
        <SpecialText speed={5} delay={next(0.02)} className="syn-property">{'  title'}</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-operator">{': '}</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-type">string</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">;</SpecialText>
      </Line>
      <Line n={l()}>
        <SpecialText speed={5} delay={next(0.02)} className="syn-property">{'  description'}</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-operator">{': '}</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-type">string</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">;</SpecialText>
      </Line>
      <Line n={l()}>
        <SpecialText speed={5} delay={next(0.02)} className="syn-property">{'  technologies'}</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-operator">{': '}</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-type">string</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">{'[];'}</SpecialText>
      </Line>
      <Line n={l()}>
        <SpecialText speed={5} delay={next(0.02)} className="syn-property">{'  liveUrl'}</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-operator">{': '}</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-type">string</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">;</SpecialText>
      </Line>
      <Line n={l()}>
        <SpecialText speed={5} delay={next(0.02)} className="syn-property">{'  githubUrl'}</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-operator">{': '}</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-type">string</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-operator">{' | '}</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-type">null</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">;</SpecialText>
      </Line>
      <Line n={l()}>
        <SpecialText speed={5} delay={next(0.02)} className="syn-punctuation">{'}'}</SpecialText>
      </Line>
      <Empty n={l()} />
      <Line n={l()}>
        <SpecialText speed={5} delay={next()} className="syn-keyword">{'const '}</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-variable">projects</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-operator">{': '}</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-type">Project</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">{'[]'}</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-operator">{' = '}</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">[</SpecialText>
      </Line>

      {projects.map((project, idx) => (
        <React.Fragment key={idx}>
          <Line n={l()}>
            <SpecialText speed={5} delay={next(0.03)} className="syn-punctuation">{'  {'}</SpecialText>
          </Line>
          <Line n={l()}>
            <SpecialText speed={5} delay={next(0.02)} className="syn-property">{'    title'}</SpecialText>
            <SpecialText speed={5} delay={next(0.01)} className="syn-operator">{': '}</SpecialText>
            <SpecialText speed={5} delay={next(0.01)} className="syn-string">{'"'}</SpecialText>
            <SpecialText speed={8} delay={next(0.01)} className="syn-string">{project.title}</SpecialText>
            <SpecialText speed={5} delay={next(0.01)} className="syn-string">{'"'}</SpecialText>
            <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">,</SpecialText>
          </Line>
          <Line n={l()}>
            <SpecialText speed={5} delay={next(0.02)} className="syn-property">{'    description'}</SpecialText>
            <SpecialText speed={5} delay={next(0.01)} className="syn-operator">{': '}</SpecialText>
            <SpecialText speed={5} delay={next(0.01)} className="syn-string">{'"'}</SpecialText>
            {project.descBefore && (
              <SpecialText speed={6} delay={next(0.01)} className="syn-string">{project.descBefore}</SpecialText>
            )}
            {project.descLinkText ? (
              <LinkPreview url={project.descLinkUrl} imageSrc={project.descLinkImg} className="text-cyan-400 hover:text-cyan-300 cursor-pointer" disabled={!linkReady[idx]}>
                <SpecialText speed={6} delay={next(0.01)} onComplete={() => setLinkReady(prev => ({...prev, [idx]: true}))}>{project.descLinkText}</SpecialText>
              </LinkPreview>
            ) : null}
            <SpecialText speed={6} delay={next(0.01)} className="syn-string">{project.descAfter}</SpecialText>
            <SpecialText speed={5} delay={next(0.01)} className="syn-string">{'"'}</SpecialText>
            <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">,</SpecialText>
          </Line>
          <Line n={l()}>
            <SpecialText speed={5} delay={next(0.02)} className="syn-property">{'    technologies'}</SpecialText>
            <SpecialText speed={5} delay={next(0.01)} className="syn-operator">{': '}</SpecialText>
            <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">[</SpecialText>
            {project.technologies.map((t, i) => (
              <React.Fragment key={i}>
                <SpecialText speed={5} delay={next(0.01)} className="syn-string">{'"'}</SpecialText>
                <SpecialText speed={5} delay={next(0.01)} className="syn-string">{t}</SpecialText>
                <SpecialText speed={5} delay={next(0.01)} className="syn-string">{'"'}</SpecialText>
                {i < project.technologies.length - 1 && <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">{', '}</SpecialText>}
              </React.Fragment>
            ))}
            <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">{'],'}</SpecialText>
          </Line>
          <Line n={l()}>
            <SpecialText speed={5} delay={next(0.02)} className="syn-property">{'    liveUrl'}</SpecialText>
            <SpecialText speed={5} delay={next(0.01)} className="syn-operator">{': '}</SpecialText>
            {project.liveUrl ? (
              <>
                <SpecialText speed={5} delay={next(0.01)} className="syn-string">{'"'}</SpecialText>
                <a className="syn-link" href={project.liveUrl} target="_blank" rel="noopener noreferrer">
                  <SpecialText speed={5} delay={next(0.01)}>{project.liveUrl}</SpecialText>
                </a>
                <SpecialText speed={5} delay={next(0.01)} className="syn-string">{'"'}</SpecialText>
              </>
            ) : (
              <SpecialText speed={5} delay={next(0.01)} className="syn-keyword">null</SpecialText>
            )}
            <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">,</SpecialText>
          </Line>
          <Line n={l()}>
            <SpecialText speed={5} delay={next(0.02)} className="syn-property">{'    githubUrl'}</SpecialText>
            <SpecialText speed={5} delay={next(0.01)} className="syn-operator">{': '}</SpecialText>
            {project.githubUrl ? (
              <>
                <SpecialText speed={5} delay={next(0.01)} className="syn-string">{'"'}</SpecialText>
                <a className="syn-link" href={project.githubUrl} target="_blank" rel="noopener noreferrer">
                  <SpecialText speed={5} delay={next(0.01)}>{project.githubUrl}</SpecialText>
                </a>
                <SpecialText speed={5} delay={next(0.01)} className="syn-string">{'"'}</SpecialText>
              </>
            ) : (
              <SpecialText speed={5} delay={next(0.01)} className="syn-keyword">null</SpecialText>
            )}
            <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">,</SpecialText>
          </Line>
          {project.tryCommand && (
            <Line n={l()}>
              <SpecialText speed={5} delay={next(0.02)} className="syn-property">{'    tryIt'}</SpecialText>
              <SpecialText speed={5} delay={next(0.01)} className="syn-operator">{': '}</SpecialText>
              <span
                className="try-command"
                onClick={onRunTstyles}
                onKeyDown={(e) => {
                  if (e.key !== 'Enter' && e.key !== ' ') return;
                  e.preventDefault();
                  onRunTstyles();
                }}
                role="button"
                tabIndex={0}
                title="Open the style picker"
              >
                <SpecialText speed={5} delay={next(0.01)} className="syn-string">{'"run '}</SpecialText>
                <SpecialText speed={6} delay={next(0.01)} className="syn-command">{project.tryCommand}</SpecialText>
                <SpecialText speed={5} delay={next(0.01)} className="syn-string">{' right here"'}</SpecialText>
              </span>
              <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">,</SpecialText>
            </Line>
          )}
          <Line n={l()}>
            <SpecialText speed={5} delay={next(0.02)} className="syn-punctuation">{'  }'}</SpecialText>
            {idx < projects.length - 1 && <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">,</SpecialText>}
          </Line>
        </React.Fragment>
      ))}

      <Line n={l()}>
        <SpecialText speed={5} delay={next(0.03)} className="syn-punctuation">{'];'}</SpecialText>
      </Line>
      <Empty n={l()} />
      <Line n={l()}>
        <SpecialText speed={5} delay={next()} className="syn-comment">{'// More projects at: '}</SpecialText>
        <a className="syn-link" href="https://github.com/fcreme" target="_blank" rel="noopener noreferrer">
          <SpecialText speed={5} delay={next(0.01)}>github.com/fcreme</SpecialText>
        </a>
      </Line>
      <Empty n={l()} />
      <Line n={l()}>
        <SpecialText speed={5} delay={next()} className="syn-keyword">{'export default '}</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-variable">projects</SpecialText>
        <SpecialText speed={5} delay={next(0.01)} className="syn-punctuation">;</SpecialText>
      </Line>
    </div>
  );
};

export default ProjectsView;
